module.exports = __webpack_public_path__ + "img/11.5c1707b8.svg";